<script setup>
import { computed, onMounted, ref } from "vue"
import { Icon } from "@components"

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

const staff = computed(() => {
    let staff_id = route.params.staff_id

    if (!staff_id) return {}

    return $appointments.staffs.find(staff => staff.staff_id == staff_id) || {}
})


const images = computed(() => {
    return staff.value.cover_images || []
})


const generateSlideArray = computed(() => {
    let list = []
    if (images.value.length == 1) return [[0, 0]]
    for (let i = 0; i < images.value.length - 1; i++) {
        list.push([i, i + 1])
    }
    return list
})

const activeSliderPage = ref(0)
// const activeSliders = computed(() => {
//     return generateSlideArray.value[activeSliderPage.value]
// })

const disable = computed(() => {
    if (activeSliderPage.value == 0) return 'prev'
    if (activeSliderPage.value == generateSlideArray.value.length - 1) return 'next'
})

const changeSlide = (option) => {
    if (option == 'next') {
        if (activeSliderPage.value == generateSlideArray.value.length - 1) return
        return activeSliderPage.value++
    }

    if (option == 'prev') {
        if (activeSliderPage.value == 0) return
        return activeSliderPage.value--
    }
}

const isActive = (index) => {
    if (!generateSlideArray.value[activeSliderPage.value]) return false
    return generateSlideArray.value[activeSliderPage.value].includes(index) ? true : false
}

const skills = computed(() => {
    let items = []

    if (staff.value.title) items.push(staff.value.title)
    if (staff.value.highlights) items.push(staff.value.highlights)

    return items
})

</script>

<template>
    <div class="staff-profile">
        <div class="staff-profile-slider" v-if="images.length > 0">
            <template v-for="(image, index) in images" :key="index">
                <div v-if="isActive(index)" class="slider-image" :style="`background-image:url(${image})`" :class="images.length == 1 ? 'w-full' : ''"></div>
            </template>
            <div class="slider-pagination" v-if="images.length > 2">
                <Icon @click="changeSlide('prev')" name="chevronLeft" size="36px" class="slider-arrow" :class="disable == 'prev' ? 'cursor-not-allowed' : ''"></Icon>
                <Icon @click="changeSlide('next')" name="chevronRight" size="36px" class="slider-arrow" :class="disable == 'next' ? 'cursor-not-allowed' : ''"></Icon>
            </div>
        </div>
        <div v-else class="staff-profile-slider">
            <!-- <div v-if="staff.thumbnail_image_url" class="slider-image" :style="`background-image:url(${staff.thumbnail_image_url});width:100%;`"></div> -->
            <div class="slider-image" :style="`background:#9999;width:100%;`"></div>
        </div>
        <div class="slider-profile-details">
            <div class="profile-image-box">
                <img :src="staff.profile_image_url ? staff.profile_image_url : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'" class="profile-image" />
                <!-- <div class="bg-[#F2F4F7] text-[#98A2B3] relative rounded-full border-4 border-[#fff] w-[96px] h-[96px] flex items-center justify-center">
                    <Icon name="user01" size="48px"></Icon>
                   {{ staff.name[0] || staff.first_name[0] || staff.last_name[0] }}
                </div> -->
            </div>

            <div class="name" :style="$customizer.subtitleStyle">{{ staff.name || staff.first_name || staff.last_name }}</div>
            <div class="details-list" v-if="skills.length">
                <div class="details-item" v-for="(skill, index) in skills" :key="index">
                    <Icon v-if="index !== 0" name="ellipse01" size="4px" class="item-icon"></Icon>
                    {{ skill }}
                </div>
            </div>

            <div class="about-box" v-if="staff.bio">
                <div class="title">About</div>
                <div class="details">{{ staff.bio }} </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss"></style>